import { createLucideIcon } from 'lucide-react';
export const CalendarIcon = createLucideIcon('calendar', [
  [
    'path',
    {
      d: 'M13.3846 12H13.8846',
      key: 'tcks1j',
    },
  ],
  [
    'path',
    {
      d: 'M13.3846 15H13.8846',
      key: 'sbjcxc',
    },
  ],
  [
    'path',
    {
      d: 'M13.3846 18H13.8846',
      key: '1vsjfg',
    },
  ],
  [
    'path',
    {
      d: 'M16 3V4',
      key: '1kjrtr',
    },
  ],
  [
    'path',
    {
      d: 'M17.0769 12H17.5769',
      key: 'smpzrt',
    },
  ],
  [
    'path',
    {
      d: 'M17.0769 15H17.5769',
      key: '31xbj2',
    },
  ],
  [
    'path',
    {
      d: 'M3 22.0232V4.02324H21V22.0232H3Z',
      key: '1anbz1',
    },
  ],
  [
    'path',
    {
      d: 'M3 8H21',
      key: '1iukdm',
    },
  ],
  [
    'path',
    {
      d: 'M6 15H6.5',
      key: '14fpgf',
    },
  ],
  [
    'path',
    {
      d: 'M6 18H6.5',
      key: '1yfbk6',
    },
  ],
  [
    'path',
    {
      d: 'M8 3V4',
      key: '11v0vl',
    },
  ],
  [
    'path',
    {
      d: 'M9.69232 12H10.1923',
      key: '1lrr6b',
    },
  ],
  [
    'path',
    {
      d: 'M9.69232 15H10.1923',
      key: '15f9un',
    },
  ],
  [
    'path',
    {
      d: 'M9.69232 18H10.1923',
      key: '1uxhc8',
    },
  ],
]);
